const BaseModule = require('../../../../90_utils/base/BaseModule');

class StatBanner extends BaseModule {

	constructor(el, params) {

		super(el);
	}

	// basemodule methods

	_domReady(){ }

	_addListeners(){ }

	_removeListeners(){ }

	// listener methods

	_onReadMoreClick(e){
		e.preventDefault();
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){

	}

	_resize(){ }
}

module.exports = StatBanner;
